"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function stubUseDispatch(sandbox, scope) {
  var dispatchStub = sandbox.stub();
  sandbox.stub(scope, "useDispatch").returns(dispatchStub);
  return dispatchStub;
}

exports.stubUseDispatch = stubUseDispatch;